import { isInsertLinkPendingOrFailed } from './isInsertLinkPendingOrFailed';

export async function getAtLeastOneInsertLinkPendingOrFailed(
    allInsertLinks: string[]
): Promise<boolean> {
    // Need to remove async and promise later as I want to check whether cloud build will give error for this
    const result = allInsertLinks.some(linkId => isInsertLinkPendingOrFailed(linkId));
    return result;
}
